import { FC } from 'react';
import Link from 'next/link';
import { FOOTER_LITRES_LFROM } from '@/helpers/variables';
import styles from './Footer.module.scss';

const Footer: FC = () => {
  const FOOTER_LINKS = [
    { link: `https://www.litres.ru/?lfrom=${FOOTER_LITRES_LFROM}`, name: 'Litres.ru' },
    { link: '/redirect_to_self_pub', name: 'Стать автором' },
    { link: '/redirect_to_my_book', name: 'MyBook.ru' },
  ];

  return (
    <ul className={styles.footer}>
      {FOOTER_LINKS.map((item, i) => (
        <li className={styles.footer__item}>
          <Link prefetch={false} target="_blank" key={`${item.name}-${i}`} className={styles.footer__link} href={item.link}>
            {item.name}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default Footer;
